//设置默认的api前缀  
export const wartApi = '/wart-api'


// PC : bolivia-mi、chile-infinix、chile-tecno、itel
// mobile : realme

// export const cid = 'realme'
export const cid = 'meizu'

// 分部ID
export const tenantId = 12
    // export const tenantId = 3


// WEBPACK FOOTER //
// ./src/config.js